import { Grid, Skeleton } from '@mui/material';

export const CreateMemberInvoiceSkeleton = () => {
  const CustomSkeleton = ({ height = '18px', width = '95%' }) => <Skeleton variant='text' animation='wave' sx={{ height, width }} />;
  return (
    <Grid container px={1}>
      <Grid item xs={12}>
        <CustomSkeleton height='60px' width='50%' />
      </Grid>
      <Grid container justifyContent='space-between'>
        <Grid item xs={5}>
          <Grid item xs={9}>
            <CustomSkeleton />
          </Grid>
          <Grid item xs={6}>
            <CustomSkeleton />
          </Grid>
          <Grid item xs={7}>
            <CustomSkeleton />
          </Grid>
        </Grid>
        <Grid item xs={5}>
          <Grid item xs={8}>
            <CustomSkeleton />
          </Grid>
          <Grid item xs={6}>
            <CustomSkeleton />
          </Grid>
          <Grid item xs={7}>
            <CustomSkeleton />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
